import { Droplet } from "lucide-react";
import { siteConfig } from "../config/siteConfig";

export const Logo = ({ compact = false, light = false }) => {
  // Se for footer (light=true) e existir logoImageFooter, usa ele
  // Senão, usa o logoImage padrão
  const logoImg = light && siteConfig.brand.logoImageFooter
    ? siteConfig.brand.logoImageFooter
    : siteConfig.brand.logoImage;

  if (logoImg) {
    return (
      <img
        src={logoImg}
        alt={siteConfig.brand.name}
        className={compact ? "h-14'" : "h-16"}
        data-testid="site-logo-image"
      />
    );
  }
  return (
    <div className="flex items-center gap-2" data-testid="site-logo">
      <span
        className="inline-flex items-center justify-center w-9 h-9 rounded-sm"
        style={{ background: "#ea580c" }}
      >
        <Droplet className="w-5 h-5 text-white" fill="white" />
      </span>
      <div className="leading-none">
        <div
          className={`font-black tracking-tight ${compact ? "text-lg" : "text-xl"} ${light ? "text-white" : "text-[#0f2a4a]"}`}
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Dr. Pipe
        </div>
        {!compact && (
          <div
            className={`text-[10px] tracking-[0.25em] uppercase font-bold ${light ? "text-orange-400" : "text-orange-600"}`}
          >
            Desentupidora 24h
          </div>
        )}
      </div>
    </div>
  );
};

export default Logo;